
class CnR {
    
    api_version = "2023-07";
    keyname = "subscriptions-2024-02";
    constructor(opts={}) {
        this.config = {...this.defaults(),...opts};
        this.inject_css()
        
    }
    defaults() {
      return {
        api_version:"2023-07",
        keyname:"subscriptions-2024-02"
      };
    }
    /* shopify cart functions */
    async getCart(url="/cart.js",extended=false,callback=()=>{}) {
        let cart = {};
        return fetch(url) 
			.then(res=>(extended)?res.text():res.json());
    }
    async updateCart(payload) {
	    return fetch(`/cart/update.js`, {
	      method: 'POST',
	      credentials: 'same-origin',
	      headers: {
	        'Content-Type': 'application/json',
	        'X-Requested-With': 'xmlhttprequest'
	      },
	      body: JSON.stringify(payload)
	    }).then((response) => response.json());
	 }
     async changeCart(payload) {
        return fetch(`/cart/change.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'xmlhttprequest'
            },
            body: JSON.stringify(payload)
          }).then((response) => response.json());
     }
     async addToCart(payload,callback) {
        return window.fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then((response) => response.json())
     }

     /* graphql functions */
     async graphql(query,params) {
        return fetch(`/api/${this.api_version}/graphql.json`,{
            method:"POST",
            headers:{
              "content-type":"application/json",
              "X-Shopify-Storefront-Access-Token":this.config.graphql_token
              },
              body:JSON.stringify({query:query,variables:params})
            })
            .then(response=>response.json())
    }
    graphql_sync(query,params) {
        let ajax = new XMLHttpRequest();
        ajax.headers = {
            "content-type":"application/json",
            "X-Shopify-Storefront-Access-Token":this.config.graphql_token
        }
        ajax.open("POST",/api/`${this.api_version}/graphql.json`,false)
        ajax.setRequestHeader("Content-Type", "application/json");
        ajax.setRequestHeader("X-Shopify-Storefront-Access-Token", storefront_token);
        ajax.send(JSON.stringify({query:query,params:params}));
        return JSON.parse(ajax.responseText);
    }
    gid2id(gid) {
      return parseInt(gid.split("/").pop())
    }
    collapse_query(object) {
      if (object==null) {
          return object;
      }
      switch(object.constructor.name) {
      case "Array":
          return object.map(item=>this.collapse_query(item));
          break;
          case "Object":
              let ret = {};
              Object.keys(object).forEach(key=>{
                  if (object[key]==null) {
                      ret[key] = null;
                      return;
                  }
                  if (object[key].reference) {
                      ret[key] = this.collapse_query(object[key].reference)
                      return;
                      
                  }
                  if (object[key].references) {                        
                      let all = [];
                      object[key].references.nodes.forEach(ref=>{
                          let crv = {};
                          ref.fields.forEach(field=>{
                              crv[field.key]=this.collapse_query(field.value)
                          })
                          all.push(crv)
                      })
                      object[key] = all;
                      
                  }
                  if (object[key].nodes && object[key].nodes.constructor.name=="Array") {
                      ret[key] = this.collapse_query(object[key].nodes);
                  } else {
                      ret[key] = this.collapse_query(object[key])
                  }
              });
              return ret
              break;
          default:
              if (object) {
                  return object;
              }
              
              break;
      }
  }     
     css() {
        return '';
     }
     inject_css() {
        let css = this.css();
        if (css.length>0) {
            let style = document.createElement("style");
            style.id=this.constructor.name.toLowerCase();
            style.textContent = this.css();
            document.querySelector("head").appendChild(style);
        }
        
     }
}
/* cnr-countdown-manager.js  */
class CnRDailyCountdown extends CnR {
    defaults() {
        return {
            cutoff:16,
            blackout_days:[],
            holidays:[],
            worker:""
        }
    }
    constructor(options) {
        super(options);
        
        this.config.holidays = this.config.holidays?this.config.holidays.split("\n").map(
            date=>new Date(date)
        ):[];
        this.countdown_worker = new Worker(this.config.worker);
        this.countdown_worker.onmessage = (event) =>{
            if (event.data.expired) {
                this.expired();
                this.countdown_worker.terminate()
            } else {
                this.render(event.data)
            }
        }
        this.countdown_worker.postMessage(this.config);

    }
    render(payload) {}
    expired() {}
}
/* docs-diesel.js  */
class DocsDieselShippingCountdown extends CnRDailyCountdown {
    expired() {
        [".cnr-shipping-countdown-mobile",".cnr-shipping-countdown"].forEach(cls=>document.querySelector(cls).innerHTML='')

        this.target().innerHTML =  ``; /* this.wrapper("Same-Day Shipping","M-F by 2pm ET",true) */
        this.setupEvents();
    }
    target() {
        return document.querySelector(window.innerWidth<1024?".cnr-shipping-countdown-mobile":".cnr-shipping-countdown")
    }
    wrapper(header,text,expired) {
        return `
        <div class="nav-user-shipping on-hours" style="display: flex; flex-direction: column">
            <div class="shipping-notice">
                <div class="shipping-notice__title ${expired?'expired':''} text-center timer-alignment">
                    <span class="text-uppercase countdown-timer" role="timer">${header}</span>
                </div>
                <div class="info">
                  <span class="shipping-notice__info">${text}</span>
                  <span class="shipping-notice__info-icon on-hours" role="button" tabindex="0" aria-label="Shipping Notice">
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" role="presentation">
                              <g clip-path="url(#clip0_2956_3007)">
                                  <path d="M4.11591 4.2388H4.86426V3.49046H4.11591M4.49009 8.35463C2.83995 8.35463 1.49665 7.01137 1.49665 5.3613C1.49665 3.71122 2.83995 2.36796 4.49009 2.36796C6.14022 2.36796 7.48352 3.71122 7.48352 5.3613C7.48352 7.01137 6.14022 8.35463 4.49009 8.35463ZM4.49009 1.61963C3.99871 1.61963 3.51214 1.71641 3.05816 1.90445C2.60419 2.09248 2.19169 2.36809 1.84424 2.71554C1.14251 3.41724 0.748291 4.36894 0.748291 5.3613C0.748291 6.35365 1.14251 7.30535 1.84424 8.00705C2.19169 8.3545 2.60419 8.63011 3.05816 8.81814C3.51214 9.00618 3.99871 9.10296 4.49009 9.10296C5.48247 9.10296 6.43421 8.70875 7.13593 8.00705C7.83766 7.30535 8.23188 6.35365 8.23188 5.3613C8.23188 4.86993 8.1351 4.38338 7.94705 3.92942C7.75901 3.47546 7.48339 3.06298 7.13593 2.71554C6.78848 2.36809 6.37598 2.09248 5.92201 1.90445C5.46803 1.71641 4.98146 1.61963 4.49009 1.61963ZM4.11591 7.23213H4.86426V4.98713H4.11591V7.23213Z" fill="#ffffff"></path>
                              </g>
                              <defs>
                                  <clipPath id="clip0_2956_3007">
                                      <rect width="8.98031" height="8.98" fill="white" transform="translate(0 0.871094)"></rect>
                                  </clipPath>
                              </defs>
                          </svg>
                    </span>
                  </span>
            </div>   
        </div>`
    }
    render(payload) {
        [".cnr-shipping-countdown-mobile",".cnr-shipping-countdown"].forEach(cls=>document.querySelector(cls).innerHTML='')
        this.target().innerHTML = this.wrapper(
          ["hours","minutes","seconds"].map(key=>payload[key]).join(":"),
          "Order by 2pm EST and we'll ship the same day",
          false
        );
        this.setupEvents()
    }
  setupEvents() {
    this.target().querySelector(".shipping-notice__info-icon").addEventListener("click",event=>{
          CnRModal.show(this.modalContent());
    })
  }
  modalContent() {
    return `
      <ul><li>Most orders placed Monday thru Friday before 2PM Eastern Time will ship the same day.</li>
      	<li>Next-Day Shipping orders placed after 2PM Eastern Friday & Saturday will not ship until Monday.</li>
      </ul>
      
       `
  }
}
/* cnr-modal/cnr-modal.js  */
class CnRModal extends CnR {
    static show(content) {
        let modal = document.querySelector(".cnr-modal");
        if (!modal) {
            modal = document.createElement("DIV");
            modal.classList.add("cnr-modal");
            document.querySelector("body").appendChild(modal);
        }
        document.querySelector("body").style.overflow = "hidden";
        modal.style.width = `${window.innerWidth}px`;
        modal.style.height = `${window.innerHeight}px`;
        modal.innerHTML = `
        <div class="modal-content">
            <span class="close">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" role="presentation"><path d="M5.86123 14.1073L5.21766 14.1073L3.67204 12.5617L3.67204 11.9181L6.68057 8.90959L3.6521 5.88112L3.6521 5.23755L5.2376 3.65205L5.88117 3.65204L8.90964 6.68052L11.9182 3.67199L12.5617 3.67199L14.1074 5.21761L14.1074 5.86118L11.0988 8.86971L14.1273 11.8982L14.1273 12.5417L12.5418 14.1273H11.8982L8.86976 11.0988L5.86123 14.1073Z" fill="#af3939"></path></svg>
            </span>
            <div class="modal-text text-left color-foreword-primary body1">
                ${content}
            </div>
        </div>
        `;
        modal.querySelector(".close").addEventListener("click",event=>{
            modal.classList.remove("active");
            document.querySelector("body").style.overflow = "auto";
            modal.innerHTML = "";
        });
        modal.addEventListener("click",event=>{
          if (event.target.classList.contains("cnr-modal")) {
            modal.classList.remove("active");
            document.querySelector("body").style.overflow = "auto";
            modal.innerHTML = "";
          }
        })
        modal.classList.add("active");
    }
  
}
/* docs-diesel-cart-limits/cnr-dd-limits.js  */
class CnRDocsDieselCartMinimum {
    defaults() {
        return {
            minimum: 0,
            button:".checkout-button",
        }
    }
    constructor(options) {
        this.config = {...this.defaults(),...options}
    }
    evaluate(subtotal) {
        let checkout_button = document.querySelector(this.config.button);
        let checkout_button_text = document.querySelector(this.config.button_text);
        if (!checkout_button || !checkout_button_text) {
          return;
        }
        if (this.config.minimum<=(subtotal/100)) {
            checkout_button.disabled = false;
            checkout_button_text.textContent = "Checkout";
        } else {
            checkout_button.disabled = true;
            checkout_button_text.innerHTML = `Add $${(this.config.minimum-(subtotal/100)).toFixed(2)} to check out`
        }
    }
}
class DocsDieselSidecartMinimum extends CnRDocsDieselCartMinimum {
    constructor(options) {
        super(options);
        document.addEventListener("rebuy:smartcart.show",event=>{
          this.evaluate(event.detail.smartcart.cart.items_subtotal_price);
        })
        document.addEventListener("rebuy:cart.add",event=>{
          this.evaluate(event.detail.cart.cart.items_subtotal_price);
        })
        document.addEventListener("rebuy:cart.change",event=>{
          this.evaluate(event.detail.cart.cart.items_subtotal_price);
        })
    }
  
}
class DocsDieselCartPageMinimum extends CnRDocsDieselCartMinimum {
    constructor(options) {
        super(options);
        document.addEventListener("CartChanged",event=>{
          this.evaluate(event.detail.items_subtotal_price);
        })
    }
    
}


